/* eslint-disable */
import type { ActionType, ProColumns } from '@ant-design/pro-table';
import { Space, Tag } from 'antd';
import { useRef, useCallback, useState } from 'react';
import { PageContainer, useAPI } from '@fregata/shared';
import { ProTable } from '@ant-design/pro-table';
import OutletLayout from 'layouts/OutletLayout';
const LAYOUT_TYPE_HORIZONTAL = 'horizontal';

//应用属性  category 0平台应用 '#1b62b7' '#fff'， 1租户自定义应用  '#a0bee1' '#fff'， 2授权应用 '#e1efff' '#1369c0'
const categoryValueEnum = {
  0: '平台应用',
  1: '租户自定义应用',
  2: '授权应用',
};
const categoryColor = {
  0: '#fff',
  1: '#fff',
  2: '#1369c0',
};
const categoryBackgroundColor = {
  0: '#1b62b7',
  1: '#a0bee1',
  2: '#e1efff',
};

const AppSearch = () => {
  const ref = useRef<ActionType>();
  const { api } = useAPI();

  const [appTotal, setAppTotal] = useState<any>();
  // 列名
  let baseColumns: ProColumns[] = [
    {
      title: '应用名称',
      dataIndex: 'queryName',
      hideInForm: true,
      hideInTable: true,
    },
    {
      title: '应用名称',
      dataIndex: 'name',
      hideInForm: true,
      hideInSearch: true,
    },
    {
      title: '应用Logo',
      dataIndex: 'logoUrl',
      hideInForm: true,
      hideInSearch: true,
      renderText: (value) => {
        return value?.startsWith('http') ? <img src={value} height={20}/> : '-';
      },
    },
    {
      title: '应用属性',
      dataIndex: 'category',
      valueType: 'select',
      hideInForm: true,
      hideInTable: true,
      valueEnum: {
        0: { text: '平台应用' },
        1: { text: '租户自定义应用' },
        2: { text: '授权应用' },
      },
    },
    {
      title: '应用属性',
      dataIndex: 'category',
      hideInSearch: true,
      render: (_, { category }) => (
        <Tag
          style={{
            border: 'none',
            color: categoryColor[category],
            backgroundColor: `${categoryBackgroundColor[category]}`,
          }}
          key={category}
        >
          {categoryValueEnum[category] || '无'}
        </Tag>
      ),
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      valueType: 'dateRange',
      hideInTable: true,
      hideInForm: true,
      search: {
        transform: (value) => {
          return {
            startDate: value[0],
            endDate: value[1],
          };
        },
      },
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      hideInForm: true,
      hideInSearch: true,
    },
  ];

  // 获取表格内容数据
  const requestData = useCallback(
    async ({ current, ...params } = {}) => {
      return api('/api/app-site/platform_app_manage/sr/page_app_vo_list', {
        handleResponse2Data: false,
        params: { pageNum: current, ...params },
      }).then((resp: any) => {
        setAppTotal(resp.data.total);

        let returnData = { data: resp.data.list, success: resp.message, total: resp.data.total };
        return returnData;
      }) as any;
    },
    [api]
  );

  return (
    <>
      <PageContainer isBody>
        <ProTable
          dateFormatter='string'
          rowKey='id'
          scroll={{ x: 1600 }}
          columns={baseColumns}
          actionRef={ref}
          request={requestData}
          tableAlertRender={false}
          tableAlertOptionRender={false}
          // options={false}
          editable={{
            type: 'multiple',
          }}
          search={{
            labelWidth: 'auto',
          }}
          pagination={{
            showSizeChanger: true,
            defaultPageSize: 10, // 默认10条/页
          }}
          headerTitle={
            <Space>
              <span>船海智云平台应用信息列表</span>
              <span style={{ color: '#1b62b7' }}>[总应用数：{appTotal}]</span>
            </Space>
          }
        />
      </PageContainer>

      <OutletLayout context={{ reload: ref.current?.reload }} />
    </>
  );
};

export default AppSearch;
